import React from 'react'
import PropTypes from 'prop-types'
import VersionedImageListContainer from '../image/VersionedImageListContainer'
import {TAB_PHOTOS} from '../../state/detail/const'


const TabPhotos = (props) => {
    const {tab, customer} = props
    if (tab !== TAB_PHOTOS) {
        return null
    }
    return (

        <React.Fragment>

            <VersionedImageListContainer customerId={customer.id}/>

        </React.Fragment>

    )
}

TabPhotos.propTypes = {
    tab: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
}

export default TabPhotos



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TabPhotos.js